import { render, staticRenderFns } from "./TraxUiResponsiveTable.vue?vue&type=template&id=1f767010"
import script from "./TraxUiResponsiveTable.vue?vue&type=script&lang=js"
export * from "./TraxUiResponsiveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports